/**
 * Default UI/Pega language when journey config has no lang
 * and the URL does not specify language / l.
 */
const DEFAULT_LANGUAGE_BY_REGION: Record<string, string> = {
  GB: 'en',
  AT: 'de',
  DE: 'de',
  IT: 'it',
  FR: 'fr',
  SG: 'zh',
};

export function getDefaultLanguageByRegion(region?: string | null): string | undefined {
  if (!region) return undefined;
  return DEFAULT_LANGUAGE_BY_REGION[region.toUpperCase()];
}
